<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2025-11-11 09:35:12
 * @LastEditors: sjq
 * @LastEditTime: 2026-05-11 16:14:57
 -->
<template>
  <div class="giftcard-success">
    <div class="success-container">
      <!-- 菜单栏（内嵌App时隐藏） -->
      <app-header :title="title" :transparent="true" back-type="back-app" />
      <!-- 礼品卡领取成功 -->
      <div class="card-status">
        <span class="img-success" :style="{ marginTop: hasHeader ? '0px' : '44px' }"></span>
        <div class="card-text">
          <div class="card-success">恭喜您！领取成功</div>
          <div class="card">{{ '快去友邻少年APP学习吧' }}</div>
        </div>
      </div>

      <!-- 用户 -->
      <div class="card-user">
        <div class="user-head-cover" v-if="drawInfo">
          <span class="img-border">
            <img class="img" :src="drawInfo.iconUrl" />
          </span>
        </div>
        <div class="user-name" v-if="drawInfo">
          <dl class="uname">{{ drawInfo.nikeName }}</dl>
          <dl class="uid">ID: {{ userId }}</dl>
        </div>

        <!-- 微信二维码 -->
        <div class="user-teacher">
          <div class="img-qrcode">
            <img class="img" :src="drawInfo === null ? defaultAdviserImg : drawInfo.adviserCode" />
          </div>
          <template v-if="isTargetGiftCard">
            <div class="img-text">少年外刊，怎么学最高效？</div>
            <div class="img-text">第一时间获取专属学习指南</div>
          </template>
          <div class="img-text">{{ isTargetGiftCard ? '立即扫码添加班主任' : '添加班主任微信，激活课程服务' }}</div>
          <!-- <div class="img-text-tip">若已有班主任请勿重复添加</div> -->
        </div>
      </div>
    </div>
    <!-- <div class="download-bar">
      <div class="down-container">
        <img src="../../images/goods/app_slogan.png" alt="" />
        <button @click="downApp">打开App</button>
      </div>
    </div> -->
  </div>
</template>

<script>
// 礼品卡领取成功
import Body from '@/mixins/body'
import { appUser } from '@/utils'
import { hasHeader } from '@/components/app/index'
import { defaultAdviserImg } from '@/pages/config'
import { getDefaultPort } from '@/api/base/host'

export default {
  name: 'giftcard-success',
  mixins: [Body],
  data() {
    return {
      title: '',
      userId: appUser.userId,
      hasHeader: hasHeader(),
      defaultAdviserImg
    }
  },
  computed: {
    drawInfo() {
      const info = this.$route.params.drawInfo

      // 页面刷新后,route.params 值被清空,vuex 中的值也被清空,所以要持久化
      if (info === undefined) {
        const obj = JSON.parse(sessionStorage.getItem('drawInfo'))
        return obj
      }
      sessionStorage.setItem('drawInfo', JSON.stringify(info))
      return info
    },
    isTargetGiftCard() {
      const targetId = getDefaultPort() === 'prod' ? 12 : 3
      return +this.giftCardId === targetId
    },
    giftCardId() {
      const id = this.$route.params.giftCardId
      if (id === undefined) {
        return sessionStorage.getItem('giftCardId')
      }
      sessionStorage.setItem('giftCardId', id)
      return id
    }
  },
  activated() {
    try {
      // 调用IOS的方法 允许左滑手势
      const bridge = window.WebViewJavascriptBridge
      if (bridge) {
        bridge.send('allowsBackForwardGestures', 'disable')
      }
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    downApp() {
      // console.log('跳转应用宝')
      // const link = document.createElement('a');
      // link.href="https://download.ylyk.com/ylsn.html"
      // link.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.zhuomogroup.ylyk';
      location.href = 'https://download.ylyk.com/ylsn.html'
      // (function(){
      //   location.href="https://download.ylyk.com/ylsn.html"
      // })()
    }
  }
}
</script>

<style lang="scss" scoped>
.giftcard-success {
  background-color: #f7f9fb;
  height: 100%;
  overflow-y: scroll;

  overflow-x: hidden;
  .success-container {
    background: url('../../images/payment/success_BG_ellipse_left.png') no-repeat,
      url('../../images/payment/success_BG_ellipse_right.png') no-repeat,
      url('../../images/payment/success_BG.png') no-repeat;
    background-color: #f7f9fb;
    background-size: 52px 79px, 65px 100px, 100% 50%;
    background-position-x: left, right, center;
    background-position-y: 25%, 10%, top;
    margin-bottom: 100px;

    .card-status {
      font-size: 18px;
      font-weight: bold;
      color: white;
      text-align: center;
      .img-success {
        display: inline-block;
        width: 48px;
        height: 48px;
        border: 1px solid rgba(255, 255, 255, 1);
        border-radius: 50%;
        margin-bottom: 20px;
        background: url('../../images/payment/icon_choose_large_def.png') no-repeat;
        background-size: 20px;
        background-position: center;
      }

      .card-text {
        .card-success {
          font-weight: bold;
          font-size: 16px;
          color: #ffffff;
          opacity: 1;
        }
        .card {
          margin-top: 10px;
          height: 17px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
          line-height: 17px;
        }
      }
    }
    .card-user {
      text-align: center;
      padding: 24px;
      padding-bottom: 40px;
      background-color: #ffffffff;
      box-shadow: 0 0 16px -4px #00000021;
      margin: 40px 20px 0;
      border-radius: 10px;
      .user-head-cover {
        margin-top: -40px;
        .img-border {
          padding: 6px;
          border-radius: 50%;
          background-color: #ffffffff;
          display: inline-block;
          .img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
          }
        }
      }
      .user-name dl {
        font-size: 14px;
        margin: 6px;
        &.uname {
          color: #000000;
          font-weight: 500;
        }
        &.uid {
          color: #666666;
          font-weight: 400;
        }
      }

      // 班主任二维码
      .user-teacher {
        margin: 20px 0;
        color: #00b25a;
        .img {
          width: 150px;
          height: 150px;
          margin: 5px 0;
          border: 1px solid #dddddd;
        }
        .img-text {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .special-content {
          margin-bottom: 15px;
          .special-title {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            margin-bottom: 8px;
          }
          .special-desc {
            font-size: 14px;
            color: #666666;
          }
        }
        .img-text-tip {
          color: #999999;
          font-size: 14px;
        }
      }
    }
  }
  .download-bar {
    position: fixed;
    bottom: 0px;
    height: 52px;
    width: 100%;
    background-color: #323232;
    opacity: 0.8;
    .down-container {
      margin: 0 17px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        height: 0.6rem;
      }
      button {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        background-color: #008888;
        color: white;
        border-radius: 13px;
        width: 66px;
        height: 26px;
      }
    }
  }
}
</style>
